import * as React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";

export function AvatarDemo() {
  return (
    <div className="flex items-center space-x-2">
      <Avatar>
        <AvatarImage src="https://github.com/ekmas.png" alt="@ekmas" />
        <AvatarFallback>SB</AvatarFallback>
      </Avatar>
      <Avatar>
        <AvatarImage src="https://github.com/shadcn.png" alt="@shadcn" />
        <AvatarFallback>CN</AvatarFallback>
      </Avatar>
      <Avatar>
        <AvatarFallback>AB</AvatarFallback>
      </Avatar>
    </div>
  );
}
